import { createActions, createReducer } from 'reduxsauce'

import TemaIndicadoresService from '../servicos/TemaIndicadoresService'
/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaTemaInicio: [],
    buscaTemaSucesso: ['tema'],
    buscaTemaErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaTema = () => {
    return dispatch => {
        dispatch(Creators.buscaTemaInicio())
        let serv = new TemaIndicadoresService()
        return serv
            .getTemas()
            .then(response => dispatch(Creators.buscaTemaSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaTemaErro(error)))
    }
}

const buscaTemaInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaTemaErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaTemaSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.tema, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_TEMA_INICIO]: buscaTemaInicio,
    [Types.BUSCA_TEMA_ERRO]: buscaTemaErro,
    [Types.BUSCA_TEMA_SUCESSO]: buscaTemaSucesso,
})
